import * as React from "react";
import type { SVGProps } from "react";
const SvgHealth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#health_svg__a)">
      <path d="M8.5 16C4.92 16 2 13.08 2 9.5V6c0-1.65 1.35-3 3-3h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1 .45-1 1v3.5C4 11.98 6.02 14 8.5 14S13 11.98 13 9.5V6c0-.55-.45-1-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.65 0 3 1.35 3 3v3.5c0 3.58-2.92 6.5-6.5 6.5" />
      <path d="M14 22c-3.86 0-7-3.14-7-7 0-.55.45-1 1-1s1 .45 1 1c0 2.76 2.24 5 5 5s5-2.24 5-5v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 3.86-3.14 7-7 7M11 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M6 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1" />
      <path d="M20 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
    </g>
    <defs>
      <clipPath id="health_svg__a">
        <path fill="#fff" d="M2 2h21v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHealth;
